import * as React from "react"
export const Svg_061 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={58}
    height={59}
    fill="none"
  >
    <g clipPath="url(#a)">
      <path
        fill="url(#b)"
        d="M53.736 55.543V16.78h-5.413V7.84h7.679V0H44.924v16.78h-5.413v38.763h-3.398V28.458H21.887v27.085H18.49V40.137H4.264v15.406H0V59h58v-3.457h-4.264Z"
      />
    </g>
    <defs>
      <linearGradient
        id="b"
        x1={13.412}
        x2={41.649}
        y1={8.85}
        y2={53.775}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h58v59H0z" />
      </clipPath>
    </defs>
  </svg>
)